<template>
  <div class="row">
    <!-- <multiselect
      v-if="isEdit"
      v-model="selectedLicense"
      id="ajax"
      label="license_name"
      track-by="id"
      :placeholder="
        typeof selectedLicense != 'undefined' &&
        typeof selectedLicense.license_name != 'undefined'
          ? selectedLicense.license_name
          : ''
      "
      open-direction="bottom"
      :custom-label="customLabelLicense"
      :options="licenseOptions"
      :multiple="false"
      :searchable="true" 
      :loading="isLoadingLicense"
      :internal-search="false"
      :close-on-select="true"
      :options-limit="300"
      :limit="3"
      style="min-width:220px"
      :limit-text="limitText"
      :max-height="600"
      :show-no-results="true"
      :hide-selected="true"
      @search-change="asyncFindLicenseSelect"
      @select="updateSelect"
      :show-labels="false"
    >
      <template slot="tag" slot-scope="{ option, remove }">
        <span class="custom__tag">
          <span>{{
            option.license_name + " (" + option.license_phone_number + ")"
          }}</span>
          <span class="custom__remove" @click="remove(option)">❌</span>
        </span>
      </template>
      <template slot="clear" slot-scope="props">
        <div
          class="multiselect__clear"
          v-if="
            typeof selectedLicense.length != 'undefined' &&
            selectedLicense.length
          "
          @mousedown.prevent.stop="clearAllLicense(props.search)"
        ></div>
      </template>
      <span slot="noResult">Oops! No elements found.</span>
    </multiselect> -->
    <a-select
      v-show="isEdit"
      show-search
      placeholder="Cari Nomor Whatsapp"
      :filter-option="false"
      style="min-width: 220px"
      @change="updateSelect"
      @search="asyncFindLicenseSelect"
      v-model="selectedLicense"
    >
      <a-select-option
        v-for="item in licenseOptions"
        :key="item.id"
        :value="item.id"
      >
        {{ item.license_name }}
        <i
          :class="{
            'text-success': item.is_online_status == 1,
            'text-danger': item.is_online_status == 0,
          }"
          :title="item.is_online_status == 1 ? 'Online' : 'Offline'"
          class="fa fa-signal"
        ></i>
        <br />
        {{ item.license_phone_number }}
      </a-select-option>
    </a-select>
    <div v-show="!isEdit">
      <span ref="license_id" id="license_id"></span>
      <!-- <template v-if="selectedLicense">
        {{ selectedLicense.license_name }}   <i
            :class="{
              'text-success': selectedLicense.is_online_status == 1,
              'text-danger': selectedLicense.is_online_status == 0,
            }"
            :title="selectedLicense.is_online_status == 1 ? 'Online' : 'Offline'"
            class="fa fa-signal"
          ></i> <br>
            <span class="text-muted"><i class="fa fa-phone"></i>  {{ selectedLicense.license_phone_number }} </span>
      </template> -->
      <!-- <span>License New<br><span class="text-muted"><i class="fa fa-phone"></i> 62895069625587</span> <i title="Offline" class="text-danger fa fa-signal"></i></span> -->
      <!-- {{ responseDet }}
        {{ licenseInfo }} -->
    </div>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    Multiselect,
  },
  data() {
    return {
      selectedLicense: [],
      licenseOptions: [],
      isLoadingLicense: false,
      responseDet: null,
      licenseInfo: null,
    };
  },
  computed: {
    isEdit: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    customLabelLicense() {
      return (option) => {
        return option.license_name + " (" + option.license_phone_number + ")";
      };
    },
    limitText() {
      return (count) => {
        return "and " + count + " more...";
      };
    },
    customLabelGroup() {
      return (option) => {
        return option.name;
      };
    },
    broadcastParamSt: {
      get() {
        return this.$store.state.omniwa.broadcastParamSt;
      },
      set(val) {
        this.$store.commit("omniwa/SET_broadcastParamSt", val);
      },
    },
  },
  created() {
    this.asyncFindLicenseSelect();
  },
  mounted() {
    // if(this.$route.query.id){
    // }
  },
  methods: {
    updateSelect() {
      this.isEdit = false;
      if (this.selectedLicense) {
        this.broadcastParamSt.license_id = this.selectedLicense;
        this.getLabel();
      }
    },
    async getLabel() {
      await this.$store
        .dispatch("license/getLicenseById", this.broadcastParamSt.license_id)
        .then((response) => {
          var { data } = response;
          this.licenseInfo = data;
          this.$refs.license_id.innerHTML = data.license_name;
          this.$refs.license_id.innerHTML +=
            '<br /><span class="text-muted"><i class="fa fa-phone"></i> ' +
            data.license_phone_number +
            "</span>";
          this.$store
            .dispatch("omniwa/isOnline", data.license_phone_number)
            .then((responseDet) => {
              var { data } = responseDet;
              this.responseDet = data;
              if (data.status === 1) {
                this.$refs.license_id.innerHTML +=
                  ' <i title="Online" class="text-success fa fa-signal"></i>';
              } else {
                this.$refs.license_id.innerHTML +=
                  ' <i title="Offline" class="text-danger fa fa-signal"></i>';
              }
            });
        });
    },
    asyncFindLicenseSelect(query = "") {
      this.licenseOptions = [];
      let serverParams = {
        license_name: query,
        id: "",
      };
      this.$store
        .dispatch("license/getLicenseList", serverParams)
        .then((response) => {
          this.licenseOptions = response.data.data;
        })
        .catch((error) => {});
    },
    clearAllLicense(query) {
      this.selectedLicense = [];
    },
  },
};
</script> 


// WEBPACK FOOTER //
// src/views/broadcast/componentsV2/Forms/formSender.vue